const icons = {
  token1: require('@/assets/image/member/token1.png'),
  // ...其他 icon key: src
}

export default {
  install(Vue) {
    // 全域注入一個 $icons 物件
    Vue.prototype.$icons = icons
  }
}